<template lang="pug">
  .nbslist
    b-container(fluid)
      b-row
        b-col.mb-3.p-0
          GeneralMenu
      b-row.thirdPart.pb-5
        b-col(cols="3")
        b-col(cols="6")
          h2.text-center NBS List
          div.line
          p.text-center For each NBS within the “Find your NBS” tool, additional information is provided below as downloadable factsheets. Each factsheet provides a general description of the NBS, basic technical information on design and performance, description of co-benefits, and project examples.
        b-col(cols="3")

      b-row.p-5
        b-col.p-5
          h3.pl-5.ml-2.mb-4(style="").titleType SELECT THE TYPE OF NATURE-BASED SOLUTION
          b-row.pl-5
            b-col(cols="4" v-for="type in type_options" :key="type.value")
              a(:href="'#'+type.value")
                b-badge.badge-style.p-3.m-2 {{ type.text }}

      b-row(v-for="type in type_options" :key="type.value" :id="type.value").p-0.pb-2.m-5
        b-col
          b-row.border-bottom.pb-2.mb-3
            b-col.p-0
              a(type="button" style="").titleType {{ type.text }}
          //b-row( v-for="subtype in sub_type_options[type.value]" :key="subtype.value")
            h5 {{ subtype.text }}
            b-col.mb-3(cols=3 v-for="tech in getTechnologySubType(subtype.value)" :key="tech.id")
              b-card(  :title="tech.name" :img-src="'/img/'+tech.image" img-top)
                b-card-text {{ tech.description }}
                b-button Download Factsheet
          //b-row(v-if="!sub_type_options[type.value]")
          b-row
            b-col.mb-3(cols=4 v-for="tech in getTechnologyType(type.value)" :key="tech.id").p-5
              b-card.border-0(  :title="tech.name" :img-src="'/img/'+tech.image" img-top)
                //b-card-text {{ tech.description }}
                b-button(:href="/factsheets/+tech.factsheet_filenames" squared variant="outline-primary" ).buttonStyle Download
          //b-card-group(deck)
          b-row


</template>

<script>
// @ is an alias to /src
import GeneralMenu from '@/components/GeneralMenu.vue'
const axios = require('axios');

export default {
  name: 'NBSList',
  data(){
    return {
      technologies: [],
      type_options: [
        { value: "CW", text: 'Constructed wetlands' },
        { value: "GR", text: 'Green Roof' },
        { value: "GW", text: 'Green Wall' },
        { value: "HA", text: 'Hydroponics/Aquaponics' },
        { value: "MS", text: 'Multi Stage' },
        { value: "I-SRS", text: 'In-stream retention systems ' },
        { value: "NW", text: 'Natural Wetlands' },
        { value: "PL", text: 'Ponds/Lagoons' },
        { value: "SIS", text: 'Soil infiltration systems' },
        { value: "WS", text: 'Willow systems' }
      ],
      sub_type_options:{
        "CW":[
          { value: "CSO_CW", text: 'CSO' },
          { value: "French_CW", text: 'French configuration' },
          { value: "VSSF_CW", text: 'Vertical' },
          { value: "HSSF_CW", text: 'Horizontal' },
          { value: "FWS_CW", text: 'Free water surface' },
          { value: "IRM_CW", text: 'Intensified reactive media' },
          { value: "IA_CW", text: 'Intensified aeration' },
          { value: "R_CW", text: 'Recirculation' }
        ],
        "MS":[
          { value: "VSSF+HSSF_CW", text: 'Vertical CW followed by horizontal CW' },
          { value: "HSSF_CW+MP_PL", text: 'Horizontal CW followed by maturation pond'},
          { value: "AP+FP_PL", text: 'Anaerobic pond followed by facultative pond ' },
          { value: "AP+FP+MP_PL", text: 'Anaerobic pond followed by facultative pond followed by maturation pond ' },
          { value: "FP+MP_PL", text: 'Facultative pond followed by maturation pond ' },
          { value: "FP_P/L+FWS_CW", text: 'Facultative pond followed by free water surface constructed wetland' },
        ],
        "HA":[
          { value: "A_HA", text: 'Aquaponics' },
          { value: "H_HA", text: 'Hydroponics' },
        ],
        "PL": [
          { value: "IA_PL", text: 'Intensified aerated ' },
          { value: "AP_PL", text: 'Anaerobic' },
          { value: "FP_PL", text: 'Facultative' },
          { value: "MP_PL", text: 'Maturation' },
        ],
        "SIS": [
          { value: "", text: 'Please select an option' },
          { value: "SIS_R", text: 'Rapid' },
          { value: "SIS_S", text: 'Slow' },
        ]
      }
    }
  },
  components: {
    GeneralMenu
  },
  methods:{
    getTechnologyType(type){
      return this.technologies.filter(tech => {
        console.log(tech, tech.name,tech.type, type, tech.type === type);
        return tech.type === type;
      })
    },
    getTechnologySubType(subtype){
      return this.technologies.filter(tech => {
        console.log(tech, tech.name,tech.type, subtype, tech.sub_type === subtype);
        return tech.sub_type === subtype;
      })
    }
  }
  ,
  mounted(){
    /* set up XMLHttpRequest */

    let _this = this;
    var url = "/excel/filtering3.xlsx";
    var oReq = new XMLHttpRequest();
    oReq.open("GET", url, true);
    oReq.responseType = "arraybuffer";

    oReq.onload = function(e) {
      var arraybuffer = oReq.response;

      /* convert data to binary string */
      var data = new Uint8Array(arraybuffer);
      var arr = new Array();
      for(var i = 0; i !== data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");

      /* Call XLSX */
      var workbook = XLSX.read(bstr, {type:"binary"});

      /* DO SOMETHING WITH workbook HERE */
      var first_sheet_name = workbook.SheetNames[0];
      /* Get worksheet */
      var worksheet = workbook.Sheets[first_sheet_name];

      _this.technologies = XLSX.utils.sheet_to_json(worksheet,{raw:true});
      //console.log(_this.technologies);
      _this.technologies.sort((a,b) => {
        if(a.type === b.type){
          return a.name >= b.type;
        }
        else return a.type >= b.type;
      });
      _this.type_options.sort((a,b) => {
        return a.value >= b.value;
      })
    };
    oReq.send();
  },
}
</script>

<style scoped>

  .badge-style{
    background-color: #F6F6F6;
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 26px;
    /* identical to box height, or 130% */

    text-transform: uppercase;

    color: #5E686D;

  }

  .buttonStyle{
    border-color: #00ACE5 !important;
    color: #00ACE5 !important;

    padding: 10px 30px;

    font-family: Lato;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 126.5%;
    /* or 20px */

    text-align: center;
    text-transform: uppercase;
  }

  .buttonStyle:hover{
    border-color: #00ACE5 !important;
    background-color: #00ACE5 !important;
    color: white !important;
  }

  .titleType{
    /* H3 */

    font-family: Lato;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 26px;
    /* identical to box height, or 130% */

    text-transform: uppercase;

    color: #5E686D;
  }

  .thirdPart{
    color: #5E686D;
    background-image: url("/images/nbslist_lead_image.jpg");
    background-size: cover;
    padding-left: 80px;
    padding-right: 80px;
  }
  .thirdPart h2{
    margin-top: 95px;
    margin-bottom: 35px;
    font-family: Lato;
    font-style: normal;
    font-weight: bold;
    font-size: 40px;
    line-height: 43px;
    text-align: center;
  }
  .thirdPart .third-text{
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 26px;
  }

  .thirdPart .line{
    width: 307px;
    border: 1px solid #5E686D;
    margin-left: auto;
    margin-bottom: 82px;
    margin-right: auto;
  }
</style>
